<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
      <v-spacer></v-spacer>
      <accumulate-nav-button></accumulate-nav-button>
    </v-app-bar>
    <v-card width="600" class="my-v-card">
      <v-card-title>住所を入力</v-card-title>
      <v-card-subtitle>配送先および請求先の情報を入力してください。</v-card-subtitle>
      <v-card-text>
        <address-input v-model="address" />
        <v-row><v-col>&nbsp;</v-col></v-row>
        <v-row><v-col>&nbsp;</v-col></v-row>
      </v-card-text>
    </v-card>
    <v-footer fixed color="var(--bg-color)">
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-btn @click="handleBack" outlined> 戻る </v-btn>
          </v-col>
          <v-col>
            <v-btn color="primary" :disabled="!isSaveButtonEnabled" @click="handleSave">
              <v-progress-circular
                v-if="isProcessing"
                indeterminate
                color="primary"
                :width="2"
                :size="20"
              ></v-progress-circular>
              {{ isProcessing ? null : '保存する' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-footer>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import AccumulateNavButton from '@/components/buttons/AccumulateNavButton.vue'
import AddressInput from '@/components/AddressInput.vue'
import { addressCollection } from '@shared/collections/address.collection'
import { PaymentMethod, userCollection } from '@shared/collections/user.collection'
import { subscriptionCollection } from '@shared/collections/subscription.collection'

const userStore = createNamespacedHelpers('user')

export default {
  components: { SeaPlusNavIcon, AccumulateNavButton, AddressInput },
  data: () => ({
    isLoading: false,
    isProcessing: false,
    /** @type {import('@shared/collections/address.collection').AddressModel} */
    address: {}
  }),
  computed: {
    ...userStore.mapState(['userId', 'user']),
    plan() {
      return this.$route.query.plan
    },
    isSaveButtonEnabled() {
      const { address } = this
      return (
        !this.isProcessing &&
        !!address.name &&
        !!address.phoneNumber &&
        !!address.postalCode &&
        !!address.prefecture &&
        !!address.address
      )
    }
  },
  methods: {
    async loadAddress() {
      /** @type {{user: import('@shared/collections/user.collection').UserModel}} */
      const { userId, user } = this
      if (userId) {
        this.isLoading = true
        this.address = (await addressCollection.findByUserId(userId)) || {}
        if (!this.address.name) {
          this.address.name = user.displayName
        }
        this.address.email = user.email
        this.isLoading = false
      }
    },
    handleBack() {
      this.$router.back()
    },
    async handleSave() {
      /** @type {{user: import('@shared/collections/user.collection').UserModel}} */
      const { userId, user, address } = this

      if (!userId) {
        return
      }

      this.isProcessing = true

      if (address.id) {
        await addressCollection.update(address.id, {
          ...address,
          email: user.email
        })
      } else {
        await addressCollection.create({
          ...address,
          userId,
          email: user.email
        })
      }
      if (user.displayName != address.name) {
        await userCollection.update(userId, {
          displayName: address.name
        })
      }

      // update bankTransferStatus if needed
      if (user && user.paymentMethod == PaymentMethod.BANK_TRANSFER && !user.bankTransferStatus) {
        await userCollection.update(userId, {
          bankTransferStatus: 'active'
        })

        await subscriptionCollection.save({
          userId,
          plan: user.plan,
          paymentMethod: user.paymentMethod,
          stripeSubscriptionId: null,
          address: await addressCollection.findByUserId(userId)
        })

        this.$router.push('/checkout/success')
      } else {
        alert('保存しました')
        this.$router.back()
      }

      this.isProcessing = false
    }
  },
  watch: {
    user() {
      this.loadAddress()
    }
  },
  mounted() {
    this.loadAddress()
  }
}
</script>
